import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRelativeActions, getRelative, getRelativeRelatives, putRelativeInfo, deleteRelativeRelatives, putRelationships } from 'services/api';

export const getRelativeAsync: any | null = createAsyncThunk(
  'relativeDetail/getRelative',
  async (data: any) => {
    const response = await getRelative(data);
    return response;
  },
);

export const getRelativeActionsAsync: any | null = createAsyncThunk(
  'relativeDetail/getRelativeActions',
  async (data: any) => {
    const response = await getRelativeActions(data);
    return response;
  },
);

export const getRelativesOfRelativeAsync: any | null = createAsyncThunk(
  'relativeDetail/getRelativesOfRelative',
  async (data: any) => {
    const response = await getRelativeRelatives(data);
    return response;
  },
);

export const putRelativeInfoAsync: any | null = createAsyncThunk(
  'relativeDetail/putRelativeInfo',
  async (data: any) => {
    const { devices, ...payload } = data; // quitamos devices para el request
    const response = await putRelativeInfo(data.id, payload);
    return response;
  },
);

export const delRelativesOfRelativeAsync: any | null = createAsyncThunk(
  'relativeDetail/deleteRelativesOfRelative',
  async (data: any) => {
    const response = await deleteRelativeRelatives(data);
    return response;
  },
);

export const putRelationshipsRelativeAsync: any | null = createAsyncThunk(
  'userDetail/putRelationships',
  async (data: any) => {
    const response = await putRelationships(data.patientId, data.relationId, data);
    return response;
  },
);
